import { Modal, Row, Col } from "react-bootstrap";

const LearnMoreComponent = (props) => {

    return (
        <Modal
            show={props.showModalLearnMore}
            onHide={props.onHideModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">About ClientConnect</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row>
                    <h1>What's Included</h1>
                    <h2>Getting Started</h2>
                </Row>

                <Row>
                    <Col md="auto">1.</Col>                    
                    
                    <Col>
                        <h3>Joining ClientConnect</h3>
                        <p>Our system will send your clients an email inviting them to join ClientConnect with a link to get started.</p>
                        <p><span>What your client sees:</span> An email with your firm name inviting them to join ClientConnect for their transaction.</p>
                    </Col>
                </Row>         

                <Row className="mb-4">
                    <Col md="auto">2.</Col>                    
                    
                    <Col>
                        <h3>Retainer Agreements</h3>
                        <p>Define a retainer agreement for your clients to sign before proceeding with their transaction.</p>
                        <p><span>What your client sees:</span> A retainer agreement presented like a terms and conditions form to agree to.</p>
                    </Col>
                </Row>      

                <h2>Client Intake and Dashboard Features</h2>

                <Row>
                    <Col md="auto">3.</Col>                    
                    
                    <Col>
                        <h3>Client Intake and Transaction Details</h3>
                        <p>A set of fields for client to fill out that will automatically populate your Realti file when you select 'Import to File'. You can define custom fields during the set up process to maximize the collection of information from your clients.</p>
                        <p><b>What your client sees:</b> A clean dashboard with a set of fields to enter their information into.</p>
                    </Col>
                </Row>

                <Row>
                    <Col md="auto">4.</Col>                    
                    
                    <Col>
                        <h3>Property Attributes</h3>
                        <p>Clients select characteristics that apply to the property from an array of options.</p>
                        <p><b>What your client sees:</b> A set of items to select from on their ClientConnect dashboard.</p>
                    </Col>
                </Row>

                <Row>
                    <Col md="auto">5.</Col>                    
                    
                    <Col>
                        <h3>Mortgage Details</h3>
                        <p>A set of basic information about your client's mortgage, including the contact details of the mortgage agent.</p>
                        <p><b>What your client sees:</b> A mortgage lender look-up window and a set of fields to enter details about their mortgage.</p>
                    </Col>
                </Row>     

                <Row className="mb-4">
                    <Col md="auto">6.</Col>                    
                    
                    <Col>
                        <h3>Document Exchange</h3>
                        <p>Send your client documents from Realti's document list, or from your computer and receive documents from your client.</p>
                        <p><b>What your client sees:</b> A section of the dashboard where received documents are displayed and an area to upload documents to you.</p>
                    </Col>
                </Row>         

                <h2>Client Task Features</h2>

                { props.province === 'AB' ? 
                    <>
                    <Row className="mb-4">
                        <Col md="auto">7.</Col>                    
                        
                        <Col>
                            <h3>Source of Funds</h3>
                            <p>Collect information regarding the sources of the funds that the client is using for the transaction.</p>
                            <p><b>What your client sees:</b>A window with fields to enter their source of funds information into.</p>
                        </Col>
                    </Row>

                    <Row>
                        <h2>Remote Closing</h2>
                    </Row>

                    <Row>
                        <Col md="auto">8.</Col>                    
                        
                        <Col>
                            <h3>Remote Closing</h3>
                            <p>A video platform with documents at the center. You can add Realti documents as well as upload other documents.</p>
                            <p><b>What your client sees:</b>A video conferencing system accessed from their ClientConnect dashboard.</p>
                        </Col>
                    </Row>
                </>
                :
                <>
                    <Row>
                        <Col md="auto">7.</Col>
                        
                        <Col>
                            <h3>KYC Verification</h3>
                            <p>Receive client ID's along with a legitimacy score applied by a system that scans the ID for signs of fraud.</p>
                            <p><b>What your client sees:</b> Instructions to download the mobile app to scan their primary ID document and submit it you.</p>
                        </Col>
                    </Row> 

                    <Row className="mb-4">
                        <Col md="auto">8.</Col>                    
                        
                        <Col>
                            <h3>Source of Funds</h3>
                            <p>Collect information regarding the sources of the funds that the client is using for the transaction.</p>
                            <p><b>What your client sees:</b>A window with fields to enter their source of funds information into.</p>
                        </Col>
                    </Row>

                    <Row>
                        <h2>Remote Closing</h2>
                    </Row>

                    <Row>
                        <Col md="auto">9.</Col>                    
                        
                        <Col>
                            <h3>Remote Closing</h3>
                            <p>A video platform with documents at the center. You can add Realti documents as well as upload other documents.</p>
                            <p><b>What your client sees:</b>A video conferencing system accessed from their ClientConnect dashboard.</p>
                        </Col>
                    </Row>
                </>
                }
            </Modal.Body>
        </Modal>
    )

}

export default LearnMoreComponent;